var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('unordered-list',{attrs:{"id":"intent-examples","is-loading":_vm.isLoading,"list":_vm.sortedIntentExamples,"list-classes":['pt-2']}})}
var staticRenderFns = []

export { render, staticRenderFns }